var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroissant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10969 18.125C2.70969 21.025 3.70969 23.925 5.60969 26.825L14.9097 18.125",
    fill: "url(#paint0_linear_20_72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10969 18.125C2.70969 21.025 3.70969 23.925 5.60969 26.825L14.9097 18.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6097 18.125C29.0097 21.025 28.0097 23.925 26.1097 26.825L16.9097 18.125",
    fill: "url(#paint1_linear_20_72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6097 18.125C29.0097 21.025 28.0097 23.925 26.1097 26.825L16.9097 18.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9092 18.125H28.0092C28.2849 18.1265 28.5569 18.0609 28.8017 17.9339C29.0465 17.8069 29.2566 17.6222 29.4141 17.3958C29.5716 17.1694 29.6717 16.9082 29.7056 16.6345C29.7396 16.3608 29.7065 16.083 29.6092 15.825C28.8321 13.3159 27.1592 11.1803 24.9092 9.82498",
    fill: "url(#paint2_linear_20_72)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9092 18.125H28.0092C28.2849 18.1265 28.5569 18.0609 28.8017 17.9339C29.0465 17.8069 29.2566 17.6222 29.4141 17.3958C29.5716 17.1694 29.6717 16.9082 29.7056 16.6345C29.7396 16.3608 29.7065 16.083 29.6092 15.825C28.8321 13.3159 27.1592 11.1803 24.9092 9.82498",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9094 18.125H3.70941C3.43365 18.1265 3.16165 18.0609 2.91689 17.9339C2.67212 17.8069 2.46194 17.6222 2.30446 17.3958C2.14698 17.1694 2.04694 16.9082 2.01296 16.6345C1.97898 16.3608 2.01207 16.083 2.10941 15.825C2.88652 13.3159 4.55939 11.1803 6.8094 9.82498",
    fill: "url(#paint3_linear_20_72)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9094 18.125H3.70941C3.43365 18.1265 3.16165 18.0609 2.91689 17.9339C2.67212 17.8069 2.46194 17.6222 2.30446 17.3958C2.14698 17.1694 2.04694 16.9082 2.01296 16.6345C1.97898 16.3608 2.01207 16.083 2.10941 15.825C2.88652 13.3159 4.55939 11.1803 6.8094 9.82498",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9095 18.125L25.1094 9.625C25.2452 9.48887 25.3491 9.32432 25.4136 9.14322C25.4781 8.96212 25.5016 8.76899 25.4825 8.5777C25.4633 8.38641 25.402 8.20173 25.3029 8.03699C25.2039 7.87225 25.0695 7.73155 24.9095 7.625C18.9095 4.125 12.9094 4.125 6.80945 7.625C6.64943 7.73155 6.51505 7.87225 6.41597 8.03699C6.31688 8.20173 6.25556 8.38641 6.23643 8.5777C6.2173 8.76899 6.24084 8.96212 6.30534 9.14322C6.36984 9.32432 6.4737 9.48887 6.60945 9.625L15.9095 18.125Z",
    fill: "url(#paint4_linear_20_72)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_72",
    x1: 2.5,
    y1: 18.5,
    x2: 8.27593,
    y2: 28.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_72",
    x1: 16.9507,
    y1: 19.4781,
    x2: 25.675,
    y2: 29.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971781,
    stopColor: "#FFA654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_72",
    x1: 15.9572,
    y1: 11.1158,
    x2: 20.9504,
    y2: 23.6162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0494067,
    stopColor: "#F26702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_72",
    x1: 4,
    y1: 8.5,
    x2: 3.85791,
    y2: 21.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_72",
    x1: 6.29695,
    y1: 7.04127,
    x2: 19.2776,
    y2: 23.1423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroissant);
export default __webpack_public_path__ + "static/media/croissant.7808777dde3a2e9eb7eb3d2df6cacf20.svg";
export { ForwardRef as ReactComponent };